import http from "../http-common";

export default class LandingPageBanners {
  getLandingBanners(path: string) {
    let url = `/landing-banners?path=${path}`;

    return http.get(url);
  }
}